import setTransition from './setTransition.js';
import transitionStart from './transitionStart.js';
import transitionEnd from './transitionEnd.js';
export default {
  setTransition,
  transitionStart,
  transitionEnd
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/core/transition/index.js
// module id = 1176
// module chunks = 9